export default {"uiPhone":"w44x4","error":"OVbz4","hint":"ycPSF","selector":"qyW-O","input":"_1UyFf"};